import { render, staticRenderFns } from "./Commoditymasterdata.vue?vue&type=template&id=3f741d59&scoped=true&"
import script from "./Commoditymasterdata.vue?vue&type=script&lang=js&"
export * from "./Commoditymasterdata.vue?vue&type=script&lang=js&"
import style0 from "./Commoditymasterdata.vue?vue&type=style&index=0&id=3f741d59&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f741d59",
  null
  
)

export default component.exports